/**
 * Date Filter Component
 * Periodos del dashboard de impacto
 */

import { cn } from '@/lib/utils';
import type { DashboardFilter } from '@/types/dashboard';

interface DateFilterProps {
  value: DashboardFilter;
  onChange: (filter: DashboardFilter) => void;
}

const FILTER_OPTIONS: { value: DashboardFilter; label: string }[] = [
  { value: 'yesterday', label: 'Ayer' },
  { value: 'this_week', label: 'Esta semana' },
  { value: 'this_month', label: 'Este mes' },
  { value: 'last_month', label: 'Mes pasado' },
  { value: 'ytd', label: 'Este año' },
];

export function DateFilter({ value, onChange }: DateFilterProps) {
  return (
    <div className="flex flex-wrap gap-2">
      {FILTER_OPTIONS.map((option) => (
        <button
          key={option.value}
          type="button"
          onClick={() => onChange(option.value)}
          aria-pressed={value === option.value}
          className={cn(
            'min-h-11 rounded-full px-4 py-2 text-sm font-light transition-all active:scale-[0.97]',
            value === option.value
              ? 'bg-[#1e1e1e] text-white'
              : 'bg-white border border-gray-200 text-[#1e1e1e] hover:bg-gray-50'
          )}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
}
